module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Underline-8771b932d3881760e1664f8d22582134.svg";